import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "p-4 bg-blue-50 text-blue-600 flex flex-col items-center justify-center"
};
const _hoisted_2 = {
  class: "font-bold"
};
import { app } from "@/di";
import { Recruiter } from "@/modules/youth/services/Recruiter";
import { EventEmitter } from "@/modules/base/events";
import { AfterDayEvaluationEvent } from "@/modules/season/events/AfterDayEvaluationEvent";
export default /*#__PURE__*/_defineComponent({
  __name: 'NegotiationSlotsBanner',
  props: {
    team: null
  },
  async setup(__props) {
    let __temp, __restore;
    const props = __props;
    const recruiter = app.get(Recruiter);
    const recruitedSlots = ref({
      recruited: 0,
      total: 0
    });
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      recruitedSlots.value = {
        recruited: await recruiter.getUsedSlots(props.team),
        total: await recruiter.getSlots(props.team)
      };
    })), __temp = await __temp, __restore(), __temp);
    onUnmounted(app.get(EventEmitter).onOff(AfterDayEvaluationEvent, refresh));
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('youth_players_recruited', recruitedSlots.value)), 1), _createTextVNode(" " + _toDisplayString(_ctx.$t('your_are_only_allowed_to_recruit_limit_amount_per_season')), 1)]);
    };
  }
});